/* eslint-disable no-unused-vars */
import * as React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  CircularProgress,
  Button,
  Grid,
  TextField,
  Typography,
  Tooltip,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTranslation } from "react-i18next";
import i18n from "../../i18";
import Nursery from "../Images/Nursery.png";
import PrimaryShool from "../Images/PrimaryShool.png";
import SecondarySchool from "../Images/SecondarySchool.png";
const GetDiscountedStudent = () => {
  const { t } = useTranslation();
  const [dataSource, setDataSource] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [setError] = React.useState(null);
  const token = localStorage.getItem("token");
  const [selectedImage, setSelectedImage] = React.useState(Nursery);
  const user = JSON.parse(localStorage.getItem("user"));
  const isRTL = i18n.language === 'ar' || i18n.language === 'ku';

  React.useEffect(() => {
    const loadUserData = () => {
      const branchId = user?.branch_id || 2;
      const branchImages = {
        1: Nursery,
        2: PrimaryShool,
        3: SecondarySchool,
      };
      setSelectedImage(branchImages[branchId] || Nursery);
    };

    loadUserData();
  }, [user]);

  const branchTitleMap = {
    1: "باخچەی منداڵانی کلیڤەری ناحکومی",
    2: "ناوەندیی کلیڤەری ناحکومی",
    3: "ئامادەی کلیڤەری ناحکومی",
  };
  const branchTitle =
    branchTitleMap[user?.branch_id] || "قوتابخانەی کلیڤەری بنەڕەتی ناحکومی";
  // Print styles with large font sizes (same as GetStudentReport)
  const printStyles = `
@media print {
     * {
        font-size: 24px !important;
      }
      
     html, body, div, span, table, tr, td, th, p, h1, h2, h3, h4, h5, h6 {
        font-size: 24px !important;
      }
      
     body, html {
        width: 100% !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        font-size: 24px !important;
        line-height: 1.5 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        background-color: white !important;
        direction: ${isRTL ? 'rtl' : 'ltr'} !important;
        text-align: ${isRTL ? 'right' : 'left'} !important;
      }

    body * {
      visibility: hidden;
      font-size: 24px !important;
    }

    .print-container, .print-container * {
      visibility: visible;
      background-color: white !important;
      font-size: 24px !important;
      direction: ${isRTL ? 'rtl' : 'ltr'} !important;
      text-align: ${isRTL ? 'right' : 'left'} !important;
    }

    .print-container {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      padding: 0;
      margin: 0;
    }

    .print-header {
      display: block !important;
      text-align: ${isRTL ? 'right' : 'center'};
      margin-bottom: 20px;
      page-break-after: avoid;
      font-size: 24px !important;
      direction: ${isRTL ? 'rtl' : 'ltr'} !important;
    }

    .print-title {
      font-size: 32px !important;
      font-weight: bold !important;
      color: #333 !important;
      margin: 20px 0 !important;
    }

    .no-print {
      display: none !important;
    }

    .table-container {
      width: 100% !important;
      margin: 0 !important;
      overflow: visible !important;
      page-break-inside: auto;
    }

    table {
      width: 100% !important;
      border-collapse: separate !important;
      border-spacing: 0 !important;
      font-size: 24px !important;
      border: none !important;
      box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
      border-radius: 8px !important;
      overflow: hidden !important;
      direction: ${isRTL ? 'rtl' : 'ltr'} !important;
    }

    th {
      background: #000080 !important;
      color: #ffffff !important;
      font-weight: 700 !important;
      font-size: 20px !important;
      text-align: ${isRTL ? 'right' : 'center'} !important;
      text-transform: uppercase !important;
      letter-spacing: 0.8px !important;
      border-bottom: 2px solid #dee2e6 !important;
      position: relative !important;
    }
    th, th * {
      background: #000080 !important;
      color: #ffffff !important;
      font-size: 20px !important;
    }
    th:first-child {
      border-top-left-radius: 8px !important;
    }
    th:last-child {
      border-top-right-radius: 8px !important;
    }
    thead {
      display: table-header-group !important;
    }
    tbody tr:nth-child(even) {
      background-color: #fafbfc !important;
    }
    tbody tr:nth-child(odd) {
      background-color: white !important;
    }
    tbody tr:hover {
      background-color: #f8f9fa !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 2px 8px rgba(0,0,0,0.08) !important;
    }
    .total-row {
      background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important;
      color: #1565c0 !important;
      font-weight: 700 !important;
      border-top: 3px solid #2196f3 !important;
      border-bottom: none !important;
      position: relative !important;
    }
    .total-row::before {
      content: '' !important;
      position: absolute !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      height: 3px !important;
      background: linear-gradient(90deg, #2196f3 0%, #1976d2 100%) !important;
    }
    .total-row td {
      background: transparent !important;
      color: #1565c0 !important;
      font-weight: 700 !important;
      font-size: 24px !important;
      border: none !important;
      border-top: 3px solid #2196f3 !important;
      padding: 20px !important;
      text-align: ${isRTL ? 'right' : 'left'} !important;
      direction: ${isRTL ? 'rtl' : 'ltr'} !important;
    }
    .total-row td:first-child {
      border-bottom-left-radius: 8px !important;
    }
    .total-row td:last-child {
      border-bottom-right-radius: 8px !important;
    }
    @page {
      size: A4;
      margin: 8mm;
    }
    .print-container th,
    .print-container th * {
      font-size: 20px !important;
      background: #000080 !important;
      color: #ffffff !important;
    }
    .print-container td,
    .print-container td * {
      font-size: 24px !important;
    }
    .print-container table {
      font-size: 24px !important;
    }
    .print-container table td {
      font-size: 24px !important;
    }
    .print-container table th {
      font-size: 20px !important;
    }

    tr {
      page-break-inside: avoid;
      page-break-after: auto;
    }

    td, th {
      padding: 16px 20px !important;
      border: none !important;
      font-size: 24px !important;
      text-align: ${isRTL ? 'right' : 'left'} !important;
      vertical-align: middle !important;
      border-bottom: 1px solid #f0f0f0 !important;
      direction: ${isRTL ? 'rtl' : 'ltr'} !important;
    }
    td {
      font-size: 24px !important;
    }
    .print-container td, .print-container th {
      font-size: 24px !important;
    }
    .print-container th {
      font-size: 20px !important;
    }
  }

  .print-header {
    display: none;
  }
`;
  const getCurrentAcademicYear = () => {
    const currentYear = new Date().getFullYear();
    return `${currentYear}-${currentYear + 1}`;
  };
  const handlePrint = () => {
    window.print();
  };

  React.useEffect(() => {
    getApiProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const getApiProducts = async () => {
    try {
      const res = await fetch(`https://api.clever-school.com/api/students`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);

      const responseData = await res.json();
      setDataSource(Array.isArray(responseData) ? responseData : []);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const parseLocalizedField = (field) => {
    try {
      return JSON.parse(field?.name || field)?.en || "N/A";
    } catch {
      return field?.name || "N/A";
    }
  };

  const columns = [
    {
      title: "#",
      render: (_, __, index) => index + 1,
    },
    {
      title: t("name"),
      render: (_, row) => row.name,
    },
    {
      title: t("class"),
      render: (_, row) => parseLocalizedField(row.class_model),
    },
    {
      title: t("section"),
      render: (_, row) => parseLocalizedField(row.section),
    },
    {
      title: t("phoneNumber"),
      render: (_, row) => row.phone_number,
    },
    {
      title: t("gender"),
      render: (_, row) => row.gender,
    },
    {
      title: t("tuitionFee"),
      render: (_, row) => {
        const tuition = row.tuitions?.[0];
        return tuition
          ? parseFloat(tuition.tuition_fee).toLocaleString("en-US")
          : "N/A";
      },
    },
    {
      title: t("discountedStudents"),
      render: (_, row) => {
        const tuition = row.tuitions?.[0];
        if (!tuition) return "N/A";
        const discount = parseFloat(tuition.discount_amount).toLocaleString(
          "en-US"
        );
        return (
          <Tooltip title={`${t("discount")}: ${discount}`}>
            <Typography sx={{ color: "#d32f2f", fontWeight: "bold" }}>
              {discount}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      title: t("reason"),
      render: (_, row) => row.tuitions?.[0]?.reason || "N/A",
    },
  ];

  const filteredData = dataSource.filter((row) => {
    const hasDiscount = row.tuitions?.some(
      (tuition) => parseFloat(tuition.discount_amount) > 0
    );

    const searchMatches = [
      row.name,
      row.phone_number,
      row.gender,
      row.tuitions?.[0]?.reason,
    ].some((val) =>
      String(val).toLowerCase().includes(searchText.toLowerCase())
    );

    return hasDiscount && searchMatches;
  });

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <style>{printStyles}</style>
      <Box
        className="print-container"
        sx={{
          direction: isRTL ? "rtl" : "ltr",
          textAlign: isRTL ? "right" : "left",
          padding: 2,
          marginBottom: 17,
          "@media print": {
            padding: 0,
            margin: 0,
            overflow: "visible !important",
            height: "auto !important",
          },
        }}
      >
        {/* Print Header */}
        <div className="print-header">
          <div
            style={{
              display: "flex",
              // maxWidth: "600px",
              margin: "0 auto",
              padding: "0",
            }}
          >
            <div
              style={{
                flex: 1,
                textAlign: "right",
                marginRight: "40px",
              }}
            >
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  marginBottom: "10px",
                }}
              >
                {branchTitle}
              </div>

              <div style={{ fontSize: "16px", marginBottom: "15px" }}>
                ساڵی خوێندن ( {getCurrentAcademicYear()} )
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100px",
                // marginLeft: "auto",
                marginLeft: "40px",
              }}
            >
              <img
                src={selectedImage}
                alt="School Logo"
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
          <hr
            style={{
              borderColor: "#000",
              margin: "20px 0",
              textAlign: "right",
            }}
          />
          <div
            className="print-title"
            style={{
              color: "red",
              fontSize: "40px",
              fontWeight: "bold",
            }}
          >
            تۆماری قوتابیان کە داشکاندنیان بۆ کراوە
          </div>
        </div>

        {/* Search and Button Grid */}
        <Grid container spacing={2} mb={2} className="no-print">
          <Grid item xs={12} sm={9}>
            <TextField
              fullWidth
              label={t("search")}
              variant="outlined"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              sx={{ "& .MuiInputBase-root": { direction: "rtl" } }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Button
              variant="contained"
              fullWidth
              onClick={handlePrint}
              sx={{
                height: 56,
                fontWeight: "bold",
                backgroundColor: "#2e7d32",
                "&:hover": { backgroundColor: "#1b5e20" },
              }}
            >
              {t("Print")}
            </Button>
          </Grid>
        </Grid>

        {/* Table */}
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: 2,
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
            overflow: "hidden",
            border: "1px solid #e9ecef",
            backgroundColor: "white",
            direction: isRTL ? "rtl" : "ltr",
            "@media print": {
              boxShadow: "0 1px 3px rgba(0,0,0,0.1) !important",
              border: "none !important",
              overflow: "visible !important",
              height: "auto !important",
              direction: isRTL ? "rtl" : "ltr",
              borderRadius: "8px !important",
            },
          }}
          className="table-container"
        >
          <Table sx={{ direction: isRTL ? "rtl" : "ltr" }}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.title}
                    sx={{
                      background: "#000080",
                      color: "#ffffff",
                      fontWeight: 700,
                      fontSize: "13px",
                      textAlign: column.align || (isRTL ? 'right' : 'center'),
                      textTransform: "uppercase",
                      letterSpacing: "0.8px",
                      padding: "16px 20px",
                      border: "none",
                      borderBottom: "2px solid #dee2e6",
                      width: column.width || "auto",
                      minWidth: column.width || "auto",
                      maxWidth: column.width || "auto",
                      "@media print": {
                        background: "#000080 !important",
                        color: "#ffffff !important",
                        fontSize: "20px !important",
                        border: "none !important",
                        borderBottom: "2px solid #dee2e6 !important",
                        width: column.width || "auto !important",
                        minWidth: column.width || "auto !important",
                        maxWidth: column.width || "auto !important",
                      },
                    }}
                  >
                    {column.title}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.map((row, index) => (
                <TableRow
                  key={row.id}
                  hover
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#fafbfc" : "white",
                    "&:hover": {
                      backgroundColor: "#f8f9fa",
                      transform: "translateY(-1px)",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    },
                    transition: "all 0.2s ease",
                    "&:last-child td": { borderBottom: 0 }
                  }}
                >
                  {columns.map((column) => (
                    <TableCell
                      key={column.title}
                      sx={{
                        border: "none",
                        borderBottom: "1px solid #f0f0f0",
                        fontSize: "20px",
                        padding: "16px 20px",
                        textAlign: column.align || (isRTL ? 'right' : 'left'),
                        verticalAlign: "middle",
                        transition: "all 0.2s ease",
                        width: column.width || "auto",
                        minWidth: column.width || "auto",
                        maxWidth: column.width || "auto",
                        "&:hover": {
                          backgroundColor: "#f8f9fa",
                          transform: "translateY(-1px)",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        },
                        "@media print": {
                          padding: "16px 20px !important",
                          border: "none !important",
                          borderBottom: "1px solid #f0f0f0 !important",
                          fontSize: "24px !important",
                          width: column.width || "auto !important",
                          minWidth: column.width || "auto !important",
                          maxWidth: column.width || "auto !important",
                        },
                      }}
                    >
                      {column.render(row, row, index)}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </LocalizationProvider>
  );
};

export default GetDiscountedStudent;
